














































































import { defineComponent, reactive, toRefs, onMounted, computed, onBeforeUnmount } from '@vue/composition-api'
import jsZip from "jszip";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { SearchCondition, Sheet, WebupHistory, WebupStatusEnum, WebupStatusNameEnum } from "../../modules/teacher/WebupList"

export interface Data {
  sheet_group_key: string
  sheet: Sheet,
  condition: SearchCondition
  webupHistories: WebupHistory[]
  submitted_at: string
  fields: any[]
  WebupStatusEnum: Readonly<{ImageReading: string; ImageReadError: string; ImageReadCompleted: string; DataRegistering: string; DataRegistrationError: string; DataRegistrationCompleted: string; Deleted: string;}>
  WebupStatusNameEnum: Readonly<{ImageReading: string; ImageReadError: string; ImageReadCompleted: string; DataRegistering: string; DataRegistrationError: string; DataRegistrationCompleted: string; Deleted: string;}>
  errors: string[]
  totalCount: number
  isMounted: boolean
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_group_key: null,
      sheet: null,
      condition: new SearchCondition(),
      webupHistories: new Array<WebupHistory>(),
      submitted_at: null,
      fields: [
        {key: "uploaded_at", label: "アップロード日時", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "file_name", label: "ファイル名", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "uploaded_user_name", label: "アップロード者", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "registered_user_name", label: "登録者", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "file_name", label: "ファイル名", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "file_count", label: "枚数", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "status", label: "状態", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "error_msg", label: "エラー", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "detail", label: "画像一覧", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "destroy", label: "削除", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
      ],
      WebupStatusEnum: WebupStatusEnum,
      WebupStatusNameEnum: WebupStatusNameEnum,
      errors: [],
      totalCount: 0,
      isMounted: false,
    });

    const statusClassStyle = (status: number) => {
      let rtn: any = {};
      if(String(status) == state.WebupStatusEnum.ImageReading || String(status) == state.WebupStatusEnum.DataRegistering){
        rtn["flash"] = true;
      }
      return rtn;
    };

    const convertUploadedAt = (uploaded_at: string) => {
      return uploaded_at ? moment(uploaded_at).format('Y年M月D日 H:m:s') : "-";
    };

    const convertWebupStatusToText = (status: number) => {
      let rtn: string = "";
      if(status == Number(state.WebupStatusEnum.ImageReading)){
        rtn = state.WebupStatusNameEnum.ImageReading;
      }else if(status == Number(state.WebupStatusEnum.ImageReadError)){
        rtn = state.WebupStatusNameEnum.ImageReadError;
      }else if(status == Number(state.WebupStatusEnum.ImageReadCompleted)){
        rtn = state.WebupStatusNameEnum.ImageReadCompleted;
      }else if(status == Number(state.WebupStatusEnum.DataRegistering)){
        rtn = state.WebupStatusNameEnum.DataRegistering;
      }else if(status == Number(state.WebupStatusEnum.DataRegistrationError)){
        rtn = state.WebupStatusNameEnum.DataRegistrationError;
      }else if(status == Number(state.WebupStatusEnum.DataRegistrationCompleted)){
        rtn = state.WebupStatusNameEnum.DataRegistrationCompleted;
      }else if(status == Number(state.WebupStatusEnum.Deleted)){
        rtn = state.WebupStatusNameEnum.Deleted;
      }
      return rtn;
    };

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    const search = async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      context.root.$store.commit("setWebupListCondition", state.condition);

      state.condition.sheet_group_key = state.sheet_group_key;

      // APIで登録済み試験情報取得
      await http.get(`/api/teacher/webup_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.webupHistories = response.data.webup_histories.map((x: any) => new WebupHistory(x));
        state.totalCount = state.webupHistories.length > 0 ? response.data.webup_histories[0].total_count : 0;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。`);
        }
        context.root.$store.dispatch("goSheetList");
      });

      context.root.$store.dispatch("hideOverlay");
    };

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    const onDrop = async (fileList: FileList) => {
      const files = [].slice.call(fileList).sort((a, b) => Common.strCmpLogicalW(a.name, b.name));
      if(files[0].name.includes(" ")){
        state.errors.push("ファイル名に半角スペースは使用できません。");
        return;
      }

      const extension = Common.getFileExtension(files[0].name);

      if(extension == "pdf"){
        // PDFの場合はファイルサイズ・ページ数チェック
        if(files[0].size > 31457280){
          state.errors.push("PDFのファイルサイズが30MBを超過しています。30MB以下にファイルを分割してアップロードしてください。");
          return;
        }

        const fileReader = new FileReader();
        fileReader.onload = async (event) => {
          const arrayBuffer = event.target.result as ArrayBuffer;
          const typedarray = new Uint8Array(arrayBuffer);
          // @ts-ignore
          await pdfjsLib.getDocument(typedarray).promise.then(async (pdfDoc: any) => {
            if(pdfDoc.numPages > 200){
              alert("PDFのページ数が200ページを超過しています。200ページ以下にファイルを分割してアップロードしてください。");
              return;
            }else{
              upload(files, pdfDoc.numPages, files[0].name);
            }
          });
        }
        fileReader.readAsArrayBuffer(files[0]);
      }else if(extension == "jpg"){
        // jpgの場合はZip圧縮してアップロード.ファイル名はそのままで
        try {
          context.root.$store.dispatch("showOverlay", "アップロード準備中です。枚数が多いと時間が掛かります。しばらくお待ちください。");

          const zip = new jsZip();

          // FileList内の全ファイルをZIPへ（同名は上書きされないように念のため重複回避）
          const used = new Set<string>();
          for (const f of files as File[]) {
            const name = ensureUniqueName(f.name, used);
            const buf = await f.arrayBuffer();
            zip.file(name, buf);
          }

          const zipBlob = await zip.generateAsync({
            type: "blob",
            compression: "DEFLATE",
            compressionOptions: { level: 9 }
          });

          // ZIPファイル名は先頭ファイル名.zip
          const zipName = files.length === 1
            ? files[0].name.replace(/\.jpg$/i, ".zip")
            : files[0].name.replace(/\.[^.]+$/i, "") + ".zip";

          const zipFile = new File([zipBlob], zipName, { type: "application/zip" });

          context.root.$store.dispatch("hideOverlay");

          upload([zipFile], files.length, files[0].name);

        } catch (e) {
          context.root.$store.dispatch("hideOverlay");
          console.error(e);
          state.errors.push("アップロード準備中にエラーが発生しました。");
        }
      }else if(extension == "zip"){
        try {
          const arrayBuffer = await files[0].arrayBuffer();
          const zip = await jsZip.loadAsync(arrayBuffer);
          const jpegCount = Object.keys(zip.files).filter(
            (name) => name.match(/\.(jpe?g)$/i)
          ).length;

          upload(files, jpegCount, files[0].name);
        } catch (e) {
          console.error(e);
          state.errors.push("ZIPファイルの解析中にエラーが発生しました。");
        }
      }
    }

    const ensureUniqueName = (name: string, used: Set<string>): string => {
      if (!used.has(name)) {
        used.add(name);
        return name;
      }
      const dot = name.lastIndexOf(".");
      const base = dot > 0 ? name.slice(0, dot) : name;
      const ext = dot > 0 ? name.slice(dot) : "";
      let i = 1;
      while (true) {
        const candidate = `${base} (${i})${ext}`;
        if (!used.has(candidate)) {
          used.add(candidate);
          return candidate;
        }
        i++;
      }
    }

    /************************************************************
     * 画像Zipドロップ
     ************************************************************/

    const upload = async (file: any[], fileCount: number, fileName: string) => {

      state.errors = [];
      
      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', file[0]);
      fd.append('file_name', fileName);
      fd.append('file_count', fileCount.toString());
      fd.append('submitted_at', state.submitted_at ? state.submitted_at : "");

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/webup_list/upload/${state.sheet_group_key}`, fd).then(async response => {
        alert("画像読込を開始します。完了するまでしばらくお待ちください。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 削除
     ************************************************************/

    const destroy = async (id: number) => {

      if(!window.confirm("アップロードデータを削除します。よろしいですか？")){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/webup_list/${id}`).then(async response => {
        alert("処理が完了しました。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      state.condition = context.root.$store.state.webupListCondition;
      await search();
      state.isMounted = true;
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      upload,
      statusClassStyle,
      convertUploadedAt,
      searchClick,
      clearCondition,
      convertWebupStatusToText,
      destroy,
      changePage,
      onDrop,
    };
  }
});

